type Command =
    | [command: 'trackEvent', category: string, action: string, name?: string, value?: number];

type PAQ = Array<Command>;

let lastCommand: Command | undefined;

function push(command: Command, unique?: true) {
    if(unique && lastCommand) {
        if(lastCommand.length === command.length &&
           lastCommand.every((v, i) => command[i] === v))
            return;
    }
    lastCommand = command;
    const _paq: PAQ | undefined = (window as any)._paq;
    _paq?.push(command);
}

export function eventCheckoutViewSummary() {
    push(['trackEvent', 'Checkout', 'View Summary']);
}

export function eventCheckoutAcceptTos() {
    push(['trackEvent', 'Checkout', 'Accept Terms of Service']);
}

export function eventCheckoutHoverOrderButton() {
    push(['trackEvent', 'Checkout', 'Hover Order Button']);
}

export function eventCheckoutHoverOfferButton() {
    push(['trackEvent', 'Checkout', 'Hover Offer Button']);
}

export function eventCheckoutClickOrderButton() {
    push(['trackEvent', 'Checkout', 'Click Order Button']);
}

export function eventCheckoutClickOfferButton() {
    push(['trackEvent', 'Checkout', 'Click Offer Button']);
}

type PaymentMethod = 'Invoice' | 'Advance' | 'Sofortüberweisung' | 'Paypal';

export function eventCheckoutSelectPaymentMethod(which: PaymentMethod) {
    push(['trackEvent', 'Checkout', 'Select Payment Method', which]);
}

type ShippingMethod = 'Default' | 'Premium' | 'Will Collect';

export function eventCheckoutSelectShippingMethod(which: ShippingMethod) {
    push(['trackEvent', 'Checkout', 'Select Shipping Method', which]);
}

export function eventCheckoutToggleNewsletter(enabled: boolean) {
    push(['trackEvent', 'Checkout', 'Toggle Newsletter Checkbox', undefined, enabled ? 1 : 0]);
}

export function eventCheckoutEnteredEmail() {
    push(['trackEvent', 'Checkout', 'Entered Email Address']);
}

export function eventNewsletterViewPopup() {
    push(['trackEvent', 'Newsletter', 'View Popup']);
}

export function eventNewsletterDismissPopup() {
    push(['trackEvent', 'Newsletter', 'Dismiss Popup']);
}

export function eventNewsletterSubscribeSuccess() {
    push(['trackEvent', 'Newsletter', 'Subscribe Success']);
}

export function eventNewsletterSubscribeFail(email: string) {
    push(['trackEvent', 'Newsletter', 'Subscribe Fail', undefined, email ? 1 : 0]);
}

export function eventNewsletterOpenPopup() {
    push(['trackEvent', 'Newsletter', 'Open Popup']);
}

export function eventCartOfferAlternative(item: V1.Product, altSize: number) {
    push(['trackEvent', 'Cart', 'Offer alternative', `${item.item_no}#${item.payload}`, altSize], true);
}

export function eventCartAcceptAlternative(item: V1.Product, altSize: number) {
    push(['trackEvent', 'Cart', 'Accept alternative', `${item.item_no}#${item.payload}`, altSize]);
}

export function eventCartRejectAlternative(item: V1.Product, altSize: number) {
    push(['trackEvent', 'Cart', 'Reject alternative', `${item.item_no}#${item.payload}`, altSize]);
}

export function eventCartDecrement(item: V1.Product, payload: string | undefined, amount: number) {
    let id = item.item_no;
    if(payload) id += `#${payload}`;
    push(['trackEvent', 'Cart', 'Decrement', id, amount]);
}

export function eventCartIncrement(item: V1.Product, payload: string | undefined, amount: number) {
    let id = item.item_no;
    if(payload) id += `#${payload}`;
    push(['trackEvent', 'Cart', 'Increment', id, amount]);
}

function eventSourceOfVisit(source: string, campaign: string | undefined) {
    push(['trackEvent', 'Source of Visit', source, campaign]);
}

{
    const query = new URLSearchParams(location.search);
    const mtm_source = (query.get('mtm_source') ?? query.get('utm_source'))?.toLowerCase(),
          mtm_campaign = (query.get('mtm_campaign') ?? query.get('utm_campaign'))?.toLowerCase();
    let source;
    if(mtm_source == 'newsletter')
        source = 'newsletter';
    else if(mtm_source == 'instagram' || mtm_campaign?.startsWith('insta'))
        source = 'instagram';
    else if(mtm_source == 'igshopping')
        source = 'igshopping';
    else if(mtm_source == 'pinterest' || mtm_campaign?.startsWith('pin'))
        source = 'pinterest';
    if(source)
        eventSourceOfVisit(source, mtm_campaign ?? undefined);
}
